import { render, staticRenderFns } from "./disbursement-profile.vue?vue&type=template&id=0005a4d0&"
import script from "./disbursement-profile.vue?vue&type=script&lang=js&"
export * from "./disbursement-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports